module.exports = __webpack_public_path__ + "static/src/content/images/brave smash.3d2c6c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/brave smash.png
// module id = L5jm
// module chunks = 0